export default "__VITE_ASSET__D0FznsT8__"